import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import CloseButton from '../react-closeButton/index';
import RoundedPrice from '../react-rounded-price/index';

import '../../../../styles/popup-general-info.scss';

const GeneralInfo = ({className, section = '', row = '', seat, onClose, price = {}, type = 'seat'}) => {
  const seatTooltipPriceInfo = (
    <div className="TooltipInfo_withSeats_body">
      <p className="TooltipInfo_withSeats_body_seat">
        <FormattedMessage id="map.tooltip.seat" defaultMessage="Seats" />
        {` ${seat}`}
      </p>
      <RoundedPrice currency={price.currency} amount={price.amount} />
    </div>
  );

  const rowTooltipPriceInfo = (
    <p className="TooltipInfo_rows_body">
      <FormattedMessage id="map.tooltip.row" defaultMessage="From" />
      <RoundedPrice currency={price.currency} amount={price.amount} />
    </p>
  );

  const seatTooltipOrRowTooltip = type === 'row' ? rowTooltipPriceInfo : seatTooltipPriceInfo;

  return (
    <div className={`TooltipInfo ${className}`}>
      <h1 className="TooltipInfo_header">
        {onClose && (
          <CloseButton
            onClose={onClose}
            className="TooltipInfo_header_closeButton"
            color="#2f343b"
            width="12px"
            height="12px"
          />
        )}
        {type === 'seat' && (
          <FormattedMessage
            id="map.tooltip.{section}.row.{row}"
            defaultMessage="{section}, Row {row}"
            values={{
              section: `${section}`,
              row: `${row}`,
            }}
          />
        )}
        {type === 'row' && (
          <FormattedMessage
            id="map.tooltip.row.{row}"
            defaultMessage="Row {row}"
            values={{
              row: `${row}`,
            }}
          />
        )}
      </h1>

      {seatTooltipOrRowTooltip}
    </div>
  );
};

GeneralInfo.propTypes = {
  /** The section name. */
  section: PropTypes.string,

  /** The row id. */
  row: PropTypes.string.isRequired,

  /** The price with currency. */
  price: PropTypes.object.isRequired,

  /** The type of tooltip. */
  type: PropTypes.string.isRequired,

  /** The seat. */
  seat: PropTypes.string,

  /** The function to close the tooltip. */
  onClose: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),

  /** The class name of the tooltip. */
  className: PropTypes.string,
};

GeneralInfo.defaultProps = {
  className: '',
};

export default GeneralInfo;
